const video = $(".video");
const mobileVideoID = $('video-js').attr('data-video-id-mobile');
const isMobileDeviceWithTablet = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|iPad/i.test(navigator.userAgent);

//- Handle About Section Dom position for mobile and desktop
const vslContainer = $('#vslSectionVsl');
const vslPlayCta = $('#playCTA');
const videoPlayer = videojs('vslSectionVsl');
const breakPoint = 768;

let windowW = window.innerWidth;

let isPlaying = false;

let isCountingPlayedTime = false;
let replayedVideoPlaceholder = false;

function addCookie() {
  videojs($('#vslContainer video-js').attr('id')).ready(function () {
    this.on('timeupdate', function () {
      if (this.currentTime() >= (60 * timePlaying) || this.currentTime() == this.duration()) {
        if (typeof loadIframe !== 'undefined' && loadIframe == true) {
          $("#vslContent").addClass('hidden');
          $("#ecomIframe").removeClass('iframe__hidden');

          if (windowW <= 1024) {
            $("#about").addClass('hidden');
          }

        } else {
          $("#vslCTA").removeClass('hide');
        }
      }
    })
  });
  $.cookie("oliveoil-vsl-rc", 1, { expires: 7 });
}

//- Handle cookies for VSL Play button
if (!$.cookie('oliveoil-vsl-rc')) {
  addCookie();

} else {
  if (typeof loadIframe !== 'undefined' && loadIframe == true) {
    $("#vslContent").addClass('hidden');
    $("#ecomIframe").removeClass('iframe__hidden');

    if (windowW <= 1024) {
      $("#about").addClass('hidden');
    }

  } else {
    $("#vslCTA").removeClass('hide');
  }
}

/**
 * Play video on the background as Thumbnail
 */
if (typeof hasVideoPlayingPlaceholder !== 'undefined' && hasVideoPlayingPlaceholder == true) {
  $('.vjs-big-play-button').show();
}

function removeAutoplayReloadVideoReplay(videoEl) {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  if (typeof hasVideoPlayingPlaceholder !== 'undefined' && hasVideoPlayingPlaceholder == true && !replayedVideoPlaceholder) {
    videoEl.muted(false);
    videoEl.autoplay(false);
    videoEl.loop(false);

    if (typeof isFullScreenInlineMobile !== 'undefined' && isFullScreenInlineMobile == false) {
      videoEl.playsinline(false);
    }

    if (isIOS) {  
      //- @QS-DEV: Please don't delete this console.log
      console.log("%c> @QS-DEV: VIDEOJS ERROR CODE:4 MEDIA_ERR_SRC_NOT_SUPPORTED when emulating iOs. Real iOS devices works fine.", "color: red; font-weight: bold;");
      // console.log('IS IOS');
      videoEl.load();
    }

    videoEl.currentTime(0);
    
    replayedVideoPlaceholder = true
  }
}

vslContainer.on('touchstart click', function () {
  // hideVideoPlayButton();
})

vslPlayCta.on('click', function () {
  playVideo();
  changeVslOnMobile(true);
  hideVideoPlayButton();

  if (typeof isFullScreenInlineDesktop !== 'undefined' && isFullScreenInlineDesktop == true && !isMobileDeviceWithTablet ||
    typeof isFullScreenInlineMobile !== 'undefined' && isFullScreenInlineMobile == true && isMobileDeviceWithTablet) {
    fullScreenVsl();

  } else if (isMobileDeviceWithTablet) {
    if (isPlaying) {
      videoPlayer.pause();

      isCountingPlayedTime = false;

      $('.vjs-big-play-button').show();

    } else {
      removeAutoplayReloadVideoReplay(videoPlayer);
  
      videoPlayer.play();
      $('.vjs-big-play-button').hide();

      isCountingPlayedTime = true;
    }

    isPlaying = !isPlaying;
  }
})

function playVideo() {
  videojs.getPlayer('vslSectionVsl').ready(function () {
    
    var myPlayer = this;

    removeAutoplayReloadVideoReplay(myPlayer);

    myPlayer.play();

    isCountingPlayedTime = true;
  });
}

function hideVideoPlayButton() {
  vslPlayCta.hide();
}

//- Different VSL on mobile and desktop
const changeVslOnMobile = (play) => {
  if (typeof mobileVideoID !== 'undefined' && mobileVideoID != '') {
    let isMobileDevice = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobileDevice) {
      const myPlayer = videojs.getPlayer($('video-js').attr('id'));
      
      if (window.innerHeight > window.innerWidth) {
        myPlayer.catalog.getVideo(mobileVideoID, function (error, video) {
          myPlayer.catalog.load(video);

          if (play) {
            removeAutoplayReloadVideoReplay(myPlayer);

            myPlayer.play();

            isCountingPlayedTime = true;

          } else {
            null;
          }
        });
      }
    }
  };
}

function fullScreenVsl() {
  window.scrollTo(0, 0);

  if ($('body').hasClass('fullScreenVsl')) {
    videoPlayer.pause();

    isCountingPlayedTime = false;

    $('.vjs-big-play-button').show();
    $('body').removeClass('fullScreenVsl');

    return

  } else {
    removeAutoplayReloadVideoReplay(videoPlayer);

    videoPlayer.play();

    isCountingPlayedTime = true;

    $('.vjs-big-play-button').hide();
    $('body').addClass('fullScreenVsl');

    return replayedVideoPlaceholder
  };
}

//- Full screen VSL
const handleFullScreenInline = (videoEl) => {
  let startScrollTop,
      endScrollTop;

  videoEl.on("touchstart", function () {
    startScrollTop = $(window).scrollTop();
  });

  videoEl.on('touchend', function () {
    endScrollTop = $(window).scrollTop();
  });

  videoEl.on('click touchend', function () {
    if (startScrollTop === endScrollTop) {
      fullScreenVsl();
    }
  });

  videoEl.one('click touchend', function () {
    removeAutoplayReloadVideoReplay(videoPlayer);
    changeVslOnMobile(true);
    hideVideoPlayButton();
  });
}

const videoPlayPause = (videoEl) => {
  let startScrollTop,
      endScrollTop;

  videoEl.on("touchstart", function () {
    startScrollTop = $(window).scrollTop();
  });

  videoEl.on('touchend', function () {
    endScrollTop = $(window).scrollTop();
  });

  videoEl.on('click touchend', function () {
    if (startScrollTop === endScrollTop) {
      if (isPlaying) {
        videoPlayer.pause();

        isCountingPlayedTime = false;

        $('.vjs-big-play-button').show();
      } else {
        removeAutoplayReloadVideoReplay(videoPlayer);

        videoPlayer.play();

        isCountingPlayedTime = true;

        hideVideoPlayButton();
        $('.vjs-big-play-button').hide();
      }

      isPlaying = !isPlaying;
    }
  });
}

if (typeof isFullScreenInlineDesktop !== 'undefined' && isFullScreenInlineDesktop == true && !isMobileDeviceWithTablet ||
  typeof isFullScreenInlineMobile !== 'undefined' && isFullScreenInlineMobile == true && isMobileDeviceWithTablet) {
  handleFullScreenInline(video);

} else if (isMobileDeviceWithTablet) {
  videoPlayPause(video);
}

changeVslOnMobile();

//-----------------------------------------------------------
//- Detect when video reach the defined time and change UTM
//-----------------------------------------------------------
if (setPlayedTime === true) {
  function returnPlayedTime() {
    if (typeof playVideoMinutes !== 'undefined' && typeof playVideoSeconds !== 'undefined') {
      let playVideoMinutesInSeconds = playVideoMinutes * 60,
          targetPlayTimeInSeconds = playVideoMinutesInSeconds + playVideoSeconds,
          currentTime = videoPlayer.currentTime(),
          playsInline = videoPlayer.getAttribute('playsinline');

      // console.log('currentTime', currentTime);
      // console.log('playVideoMinutes', playVideoMinutes);

      // console.log('isCountingPlayedTime', isCountingPlayedTime);

      // Check if the current play time is greater than the targeted time
      if (currentTime > targetPlayTimeInSeconds && isCountingPlayedTime) {
        // console.log('originalUtmContent', originalUtmContent);
        // console.log('targetPlayTimeInSeconds', targetPlayTimeInSeconds);

        if (typeof originalUtmContent !== 'undefined') {

          const splitFullOriginalUtmContent = originalUtmContent.split('-');

          let newUtmContent = splitFullOriginalUtmContent[0] + '-' + splitFullOriginalUtmContent[1] + '-' + splitFullOriginalUtmContent[2] + '-' + splitFullOriginalUtmContent[3] + playVideoMinutes + '-' + splitFullOriginalUtmContent[4];

          // console.log('>> New UTM Content', newUtmContent);

          $('[data-param]').each(function (index) {
            const paramTargetPrefix = $(this).attr('data-param').split('utm_content=')[0];
            $(this).attr('data-param', `${paramTargetPrefix}utm_content=${newUtmContent}`);

            const hrefTargetPrefix = $(this).attr('href').split('utm_content=')[0];
            $(this).attr('href', `${hrefTargetPrefix}utm_content=${newUtmContent}`);
          });
        }

        clearInterval(interval);
      }
    }
  }

  let interval = setInterval(returnPlayedTime, 1000);
}